import React from 'react'
import Alert, { AlertInput } from 'src/components/common/Alert'

type DashboardAlertsProps = {
  rateAlert: AlertInput
  listAlert: AlertInput
  onCloseRate: () => void
  onCloseList: () => void
}

const DashboardAlerts: React.FC<DashboardAlertsProps> = ({
  rateAlert,
  listAlert,
  onCloseRate,
  onCloseList,
}) => {
  return (
    <>
      <Alert alert={rateAlert} duration={2200} onClose={onCloseRate} />
      <Alert alert={listAlert} duration={3200} onClose={onCloseList} />
    </>
  )
}

export default DashboardAlerts
